import { Calculator, X } from 'lucide-react'

export default function BulkActionBar({
  count,
  onAddToCalculator,
  onClear,
}: {
  count: number
  onAddToCalculator: () => void
  onClear: () => void
}) {
  if (count === 0) return null
  return (
    <div className="fixed inset-x-0 bottom-6 z-40 flex justify-center px-4">
      <div className="flex items-center gap-4 rounded-r-2 border border-line-soft bg-surface-base px-4 py-2.5 shadow-lf-pop">
        <span className="lf-body-sm text-fg-1">
          <span className="font-medium text-brand-pink">{count}</span>명 선택됨
        </span>
        <button
          type="button"
          onClick={onAddToCalculator}
          className="flex items-center gap-1.5 rounded-r-1 bg-brand-pink px-3 py-1.5 lf-body-sm font-medium text-brand-brown hover:opacity-90"
        >
          <Calculator size={15} /> 견적 계산기에 담기
        </button>
        <button
          type="button"
          onClick={onClear}
          className="flex items-center gap-1 lf-caption text-fg-3 hover:text-fg-1"
        >
          <X size={14} /> 해제
        </button>
      </div>
    </div>
  )
}
